module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-1-nad_600px_width-0_1.029def2b.png";